import { PROVIDER_DISPLAY_NAMES, type ServerProvider } from "@cmmd-forge/contracts";
import { sanitizePublicProviderText } from "@cmmd-forge/shared/publicProviderCopy";
import { memo } from "react";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { CircleAlertIcon } from "lucide-react";

export const ProviderStatusBanner = memo(function ProviderStatusBanner({
  status,
}: {
  status: ServerProvider | null;
}) {
  if (!status || status.status === "ready" || status.status === "disabled") {
    return null;
  }

  const providerLabel = PROVIDER_DISPLAY_NAMES[status.provider] ?? status.provider;
  const defaultMessage =
    status.status === "error"
      ? `${providerLabel} provider is unavailable.`
      : `${providerLabel} provider has limited availability.`;
  const title = `${providerLabel} provider status`;
  const message = sanitizePublicProviderText(status.message, { fallback: defaultMessage });

  return (
    <div className="pt-3 mx-auto max-w-3xl">
      <Alert variant={status.status === "error" ? "error" : "warning"}>
        <CircleAlertIcon />
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription className="line-clamp-3" title={message ?? defaultMessage}>
          {message ?? defaultMessage}
        </AlertDescription>
      </Alert>
    </div>
  );
});
